







import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";

@Component
export default class Companys extends AbpBase {
  
  tableHeight=330
   list=[];
   async getEquipmentCount(){
   let list = await this.$store.dispatch({
      type: "thequipment/getCountHomeEchart",
    });
    for(var i=0;i<list.length;i++){
      this.list.push({cName:list[i].fname,count:list[i].zCount})
    }
  }
  created() {
    this.getEquipmentCount();
  }

  mounted() { 
    this.tableHeight=this.$refs.refwarningmain.offsetHeight-60;
  }
  columns1= [
    {
      title: "企业名称",
      key: "cName",
    },
    {
      title: "设备数量",
      key: "count",
    }
  ]
}
